import { ChangeDetectionStrategy, Component, computed, inject, input, signal } from '@angular/core';
import { BasePageComponent, NoResultComponent, AbstractPageComponent } from '@spike/scaffolds';
import { PaginatorModule } from "primeng/paginator";
import { CommonModule } from '@angular/common';
import { ResourceApiService } from '@spike/core';
import { PositionsTableComponent } from "../../components/positions-table/positions-table";
import { PositionsFiltersFormComponent } from '../../forms/positions-filters-form/positions-filters-form';
import { OrderPageComponent } from "../order-page/order-page";
import { WorkflowState } from 'src/app/features/workflow/models/workflow-status.enum';
import { EntityApiEnum } from 'src/app/config/entity-api.enum';
import { PaginationModel } from 'src/app/features/shared/models/pagination-model';
import { SortingModel } from 'src/app/features/shared/models/sorting.model';
import { AvanzamentiPosizioni } from '../../models/avanzamenti-posizioni.model';


@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'spike-positions-page',
  providers:[],
  imports: [BasePageComponent, CommonModule, NoResultComponent, PaginatorModule, PositionsFiltersFormComponent, PositionsTableComponent, OrderPageComponent],
  templateUrl: './positions-page.html',
  
})
export class PositionsPageComponent extends AbstractPageComponent{
  // Inject
  private readonly resourceApi = inject(ResourceApiService);

  // Inputs
  readonly workflowState= input.required<WorkflowState>();

  //static
  private readonly entityApi = EntityApiEnum.POSITION;


  //local state
 public readonly searchFilter = signal<any>({});

  public resourceFilter = computed(()=>{
    const searchFilter = this.searchFilter()
    const workflowState = this.workflowState();
    const pagination = this.pagination();
    const sorting = this.sorting();
    const filter = workflowState.stateFlag ? {...searchFilter, [workflowState.stateFlag]: 1} : {...searchFilter};
    return { filter: filter,  likable: true, currentPage: pagination.currentPage, maxResultPerPage: pagination.rows, orderByClause: sorting.orderByClause, orderDirection: sorting.orderDirection };

  })

  public pagination = signal<PaginationModel>({ rows: 25, currentPage: 0, first: 0, rowsPerPageOptions: [25, 50, 100] });
  public sorting = signal<SortingModel>({ orderByClause: 'position_expire_date', orderDirection: 'desc' });
  public selectedItem = signal<AvanzamentiPosizioni|undefined>(undefined);

   //resource
  public readonly entityList = this.resourceApi.call<any>(signal(this.entityApi), signal('searchAvanzamentoPosizioni'), this.resourceFilter); 

  public isDetailVisible = computed(()=>{
    const selectedItem = this.selectedItem();
    return selectedItem ? true :false;
  });

  public onPageChange(event: any): void {
    this.pagination.update(p => ({...p, rows: event.rows || p.rows, first: event.first || 0, currentPage: event.page || 0}));
  }

  public onSort(sortingModel: SortingModel) {
    this.sorting.set(sortingModel);
  }


  public onSave(){
    this.entityList.reload();
  } 

}